import { render, staticRenderFns } from "./AreaCommitmentsCollapse.vue?vue&type=template&id=4d48a2ae"
import script from "./AreaCommitmentsCollapse.vue?vue&type=script&lang=js"
export * from "./AreaCommitmentsCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports